(function () {
  function initCollectionFilters() {
    var fallback = document.querySelector('[data-mih-filter-fallback]');
    var grid = document.querySelector('[data-mih-product-grid]');
    if (!fallback || !grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.mih-pcard'));
    var countEl = document.querySelector('[data-mih-product-count]');

    function getSelectedTags() {
      return Array.prototype.slice
        .call(fallback.querySelectorAll('[data-mih-filter="tag"]:checked'))
        .map(function (el) { return el.value; });
    }

    function getAvailability() {
      return Array.prototype.slice
        .call(fallback.querySelectorAll('[data-mih-filter="availability"]:checked'))
        .map(function (el) { return el.value; });
    }

    function applyFilters() {
      var tags = getSelectedTags();
      var availability = getAvailability();
      var min = parseFloat(fallback.querySelector('[data-mih-filter="price-min"]')?.value || '');
      var max = parseFloat(fallback.querySelector('[data-mih-filter="price-max"]')?.value || '');
      var visible = 0;
      var inStock = 0;
      var outStock = 0;

      cards.forEach(function (card) {
        var cardTags = (card.dataset.mihTags || '').split('|');
        var price = parseFloat(card.dataset.mihPrice || '0');
        var avail = card.dataset.mihAvailability;
        var show = true;

        if (availability.length && availability.indexOf(avail) === -1) show = false;
        if (show && tags.length && !tags.some(function (t) { return cardTags.indexOf(t) !== -1; })) show = false;
        if (show && !isNaN(min) && price < min) show = false;
        if (show && !isNaN(max) && price > max) show = false;

        card.style.display = show ? '' : 'none';
        if (show) visible++;
        if (avail === 'in-stock') inStock++;
        else outStock++;
      });

      if (countEl) countEl.textContent = visible + ' products';
      var inEl = fallback.querySelector('[data-count-for="in-stock"]');
      var outEl = fallback.querySelector('[data-count-for="out-of-stock"]');
      if (inEl) inEl.textContent = '(' + inStock + ')';
      if (outEl) outEl.textContent = '(' + outStock + ')';
    }

    fallback.querySelector('[data-mih-filter-apply]')?.addEventListener('click', applyFilters);
    fallback.querySelector('[data-mih-filter-clear]')?.addEventListener('click', function () {
      fallback.querySelectorAll('input[type="checkbox"]').forEach(function (el) {
        el.checked = el.value === 'in-stock';
      });
      fallback.querySelectorAll('input[type="number"]').forEach(function (el) { el.value = ''; });
      applyFilters();
    });

    fallback.querySelectorAll('[data-mih-filter="availability"], [data-mih-filter="tag"]').forEach(function (el) {
      el.addEventListener('change', applyFilters);
    });

    applyFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionFilters);
  } else {
    initCollectionFilters();
  }
})();
